import React from 'react'
import styled from 'styled-components'
import { SectionHeader } from '@giphy/react-giphy-brand'
import { giphyLightGrey, giphyCharcoal } from '@giphy/js-brand'
import TitleInput from 'shared/components/edit-panel/info/video-title/input'

export const TITLE_MAX_LENGTH = 50

const Container = styled.div`
    margin-bottom: 20px;
`

const Label = styled(SectionHeader)`
    color: ${giphyLightGrey};
    display: flex;
    justify-content: space-between;
    font-weight: bold;
    margin-bottom: 8px;
`

const Requirement = styled.span`
    font-size: 12px;
    color: ${giphyCharcoal};
`

type Props = {
    value?: string
    onChange: (data: object) => void
}

const VideoTitle = ({ value = '', onChange }: Props) => {
    return (
        <Container>
            <Label>
                <span>Video Title</span>
                <Requirement>Required</Requirement>
            </Label>
            <TitleInput value={value} onChange={value => onChange({ videoTitle: value })} />
        </Container>
    )
}

export default VideoTitle
